// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2DYu1","title":"Header_title__3Qevw","side":"Header_side__14F6N"};